import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
  provideAppInitializer,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig,
} from '@angular/router';

import { appRoutes } from './app.routes';
import { traceparentInterceptor } from './core/telemetry/traceparent.interceptor';
import { configureAmplify } from './features/auth/amplify.config';
import { setupGlobalAuthListener } from './features/auth/auth-event.listener';
import { authInterceptor } from './features/auth/interceptors/auth.interceptor';
import { errorInterceptor } from './features/auth/interceptors/error.interceptor';
import { mockInterceptor } from './mocks/mock.interceptor';

import type { ApplicationConfig } from '@angular/core';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    ),
    // インターセプターの順序: mock → traceparent → auth → error
    // mock が先に処理し、traceparent が trace 文脈（traceparent ヘッダ）を付与、
    // auth がトークンを付与、error が最後にエラーをキャッチする
    provideHttpClient(
      withInterceptors([
        mockInterceptor,
        traceparentInterceptor,
        authInterceptor,
        errorInterceptor,
      ]),
    ),
    provideAppInitializer(() => {
      configureAmplify();
    }),
    provideAppInitializer(() => {
      setupGlobalAuthListener();
    }),
  ],
};
